import { makeDefaultTypographyStyled } from '../typography-styled';

export const StyledHeading4 = makeDefaultTypographyStyled(
  'Heading4',
  'h4',
  1.44,
  1.2,
);
